import React, { useEffect, useState } from "react";
import axios from "axios";
import BreadCrumb from "../components/BreadCrumb";

const About = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("https://app.endorselearning.co.uk/api/cms/1")
      .then(response => {
        setAboutData(response.data.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching about data:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!aboutData) {
    return <p>Error loading content.</p>;
  }

  return (
    <>
      <BreadCrumb />
      <section className="section-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div dangerouslySetInnerHTML={{ __html: aboutData.description }} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
